module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_studio@2x-6122b83a8c45d6da1fa9b3fd78131e7b.webp";